import { useEffect, useState } from 'react'
import { getAnonSession } from '@fs/zion-session'
import zionDebug from '@fs/zion-debug'

// turn on in browser console with: localStorage.debug = 'fs:search:auth:*'
const debug = zionDebug('search:auth:useAnonSession')

/**
 * Force an anonymous session before rendering — the Platform API requires it. This synchronizes
 * with an external system (the session service), so it stays in an effect, but the effect is
 * isolated here to keep the route components declarative.
 *
 * getAnonSession is async, so rejection is handled with .catch (a try/catch would only catch a
 * synchronous throw and miss the Promise rejection).
 *
 * @returns {{ sessionStarted: boolean, error: unknown }}
 */
export default function useAnonSession() {
  const [sessionStarted, setSessionStarted] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    getAnonSession()
      .then((session) => {
        if (!cancelled) {
          debug('got anonymous session', session)
          setSessionStarted(true)
        }
      })
      .catch((e) => {
        if (!cancelled) {
          // fall back to a sentinel so a falsy rejection still fails closed (consumers check truthiness)
          setError(e || new Error('Could not get anonymous session'))
        }
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { sessionStarted, error }
}
